"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var kb_utilities_1 = require("../kb.utilities");
function deserializeMetaCategories(values) {
    return immutable_1.List(values).map(createMetaCategory);
}
exports.deserializeMetaCategories = deserializeMetaCategories;
function createMetaCategory(category) {
    var metaCategory = (lodash_1.mapValues(category, function (value, key) {
        if (Array.isArray(value)) {
            return immutable_1.List(value);
        }
        else if (key === skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE) {
            return skynet_store_utilities_1.deserializeMultilingual(value);
        }
        else {
            return skynet_store_utilities_1.deserializeIfMultilingual(value);
        }
    }));
    return kb_utilities_1.makeValueObject(metaCategory, function (first, other) {
        return kb_utilities_1.toLower(first.metaCategoryId.systemName) ===
            kb_utilities_1.toLower(other.metaCategoryId.systemName);
    }, function (obj) { return immutable_1.hash(obj.metaCategoryId.systemName); });
}
exports.createMetaCategory = createMetaCategory;
function serializeMetaCategory(category) {
    return (lodash_1.mapValues(category, function (value, key) {
        if (immutable_1.List.isList(value)) {
            return value.toJS();
        }
        else if (key === skynet_store_kb_api_1.ENTITY_MULTILINGUAL_NAME_ATTRIBUTE) {
            return skynet_store_utilities_1.serializeMultilingualString(value);
        }
        else {
            return value;
        }
    }));
}
exports.serializeMetaCategory = serializeMetaCategory;
function convertCategoryToSavable(category) {
    return {
        displayName: category.displayName,
        displayNameMultilingual: category.displayNameMultilingual,
        hasCustomSorting: category.hasCustomSorting,
        isRoot: category.isRoot,
        hasIcon: category.hasIcon,
        iconId: category.iconId,
        isCacheable: category.isCacheable,
        isChild: category.isChild,
        isClassifier: category.isClassifier,
        isSearchable: category.isSearchable,
        isWithEditableForm: category.isWithEditableForm,
        isWithVersioning: category.isWithVersioning,
        showInCategoryManager: category.showInCategoryManager,
        systemName: category.metaCategoryId.systemName,
        tableName: category.tableName,
        wfProcessId: category.wfProcessId,
        sortInfo: category.sortInfo,
        fields: [],
    };
}
exports.convertCategoryToSavable = convertCategoryToSavable;
//# sourceMappingURL=category.serializer.js.map